import { redirect, RouteObject } from 'react-router';

import { SelfServiceErrorBoundary } from './components/Error/SelfServiceErrorBoundary';
import InitialPageNavigator from './components/InitialPageNavigator/InitialPageNavigator';
import { TicketOutlet } from './components/TicketOutlet/TicketOutlet';
import { TicketRoutePaths } from './interfaces/Routes';
import {
  Appointment,
  Cancel,
  Change,
  Confirm,
  Contact,
  Customer,
  FAQ,
  Meterkast,
  MeterkastPrivacyPolicy,
  MeterkastScheduled,
  Questions
} from './pages';
import SignatureComponent from './pages/Signature/Signature';
import { signatureOutletLoader, ticketOutletLoader } from './services/LoaderService';
import { InitType } from './services/RouteService';
import StepsService from './services/StepsService';

const backwardsCompatibilityRedirectRoute = (initType: InitType, path: TicketRoutePaths): RouteObject => {
  return {
    path: `${initType}/:hashId`,
    loader: ({ params }) => redirect(StepsService.getStepUri(params.hashId, path)),
  };
};

export const routes: RouteObject[] = [
  backwardsCompatibilityRedirectRoute(InitType.cancel, TicketRoutePaths.cancel),
  backwardsCompatibilityRedirectRoute(InitType.signature, TicketRoutePaths.signature),
  backwardsCompatibilityRedirectRoute(InitType.ticket, TicketRoutePaths.index),
  {
    path: ':hashId',
    element: <TicketOutlet />,
    loader: (args) => ticketOutletLoader(args.params.hashId!),
    shouldRevalidate: ({ currentParams, nextParams }) => currentParams.hashId !== nextParams.hashId,
    ErrorBoundary: SelfServiceErrorBoundary,
    children: [
      { path: TicketRoutePaths.appointment, Component: Appointment },
      { path: TicketRoutePaths.change, Component: Change },
      { path: TicketRoutePaths.confirm, Component: Confirm },
      { path: TicketRoutePaths.contact, Component: Contact },
      { path: TicketRoutePaths.customer, Component: Customer },
      { path: TicketRoutePaths.cancel, Component: Cancel },
      { path: TicketRoutePaths.faq, Component: FAQ },
      { path: TicketRoutePaths.meterkast, Component: Meterkast },
      { path: TicketRoutePaths.meterkastPrivacyPolicy, Component: MeterkastPrivacyPolicy },
      { path: TicketRoutePaths.meterkastScheduled, Component: MeterkastScheduled },
      { path: TicketRoutePaths.questions, Component: Questions },
      {
        path: TicketRoutePaths.signature,
        Component: SignatureComponent,
        errorElement: <SelfServiceErrorBoundary withAppView={false} />,
        loader: (args) => signatureOutletLoader(args.params.hashId!),
      },
      { index: true, Component: InitialPageNavigator },
      {
        path: '*',
        loader: ({ params }) => redirect(`/${params.hashId}`),
      }
    ]
  }, {
    index: true,
    loader: () => {
      return redirect('https://guidion.com');
    },
  }];
